import { useTranslation } from 'react-i18next';
import { FileTypeFile as FileTypeFileIcon } from '@otp/icons';
import clsx from 'clsx';
import styles from './style.module.css';
import { Button } from '@otp/ui';
import { ResourcePageType } from 'src/graphql/generated/graphql';

export const ResourceUploaderContent = ({
  type = ResourcePageType.Document,
  disabled,
  loading,
}: {
  type?: ResourcePageType;
  disabled?: boolean;
  loading?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col pb-4">
      <div className="flex justify-center">
        <FileTypeFileIcon
          className={clsx('scale-[3] h-20', {
            [styles.documentAnimation]: loading,
          })}
        />
      </div>
      <div>
        {t(
          `resources.form.fields.my-attachments-extra-content-${type.toLowerCase()}`,
        )}
      </div>
      <Button
        variant="contained"
        color="primary"
        className="mt-2"
        disabled={disabled}
      >
        {t('resources.form.fields.my-attachments-button')}
      </Button>
    </div>
  );
};
